import classNames from 'classnames'
import { useTranslator } from '../translator/hook'
import './smallButtonUpdate.css'
import { useProject } from '../project/hook'
import PlayIcon from '../buttons/icons/playIcon'
import { useTooltip } from '../tooltipHook'
import { Tooltip } from '../tooltip'
import { LoadingBox } from '../loading/loadingBox'
import { useState } from 'react'
interface SmallButtonUpdateProps {
  connected: boolean
  isWide: boolean
  tooltipLabel?: string
  onReflect?: () => Promise<void>
}
export const SmallButtonUpdate = ({
  connected,
  isWide,
  tooltipLabel,
  onReflect,
  ...rest
}: SmallButtonUpdateProps) => {
  const { t } = useTranslator()
  const { saveProject } = useProject()
  const { getReferenceProps, refs, tooltipProps } = useTooltip({
    placement: 'bottom-end',
  })

  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    if (!connected) {
      return
    }
    try {
      await onReflect?.()
    } catch (error) {
      console.error('onReflect failed:', error)
    }
    setIsLoading(true)
    try {
      const isSaved = await saveProject()
      if (!isSaved) {
        return
      }
      await new Promise((resolve) => setTimeout(resolve, 5000)) //プラグイン側の反映が最大5秒かかるので待つ
    } catch (error) {
      console.error('Project save failed:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadingBox loading={isLoading} />
      <div
        ref={refs.setReference}
        {...getReferenceProps()}
        className={classNames('update-small-button', {
          'connected-update-small-button': connected,
        })}
        aria-disabled={!connected}
        {...rest}
        onClick={() => handleClick()}
      >
        {tooltipLabel && (
          <Tooltip
            {...tooltipProps}
            className="linkage-button-tooltip"
            disabled={isWide}
          >
            {tooltipLabel}
          </Tooltip>
        )}
        <PlayIcon className={isWide ? 'icon_play' : ''} />
        {isWide && t('update')}
      </div>
    </>
  )
}
